import { createMuiTheme } from "@material-ui/core";
const defaultTheme = createMuiTheme();

export default {
  typography: {
    fontFamily: "Rubik",
    h1: {
      fontWeight: 700,
      fontSize: 80,
      lineHeight: 1.25,
      letterSpacing: 1.5,
      [defaultTheme.breakpoints.down("md")]: {
        fontSize: 72,
      },
      [defaultTheme.breakpoints.down("xs")]: {
        fontSize: 48,
      },
    },
    h2: {
      fontWeight: 700,
      fontSize: 60,
      lineHeight: 1.15,
      [defaultTheme.breakpoints.down("sm")]: {
        fontSize: 45,
      },
      [defaultTheme.breakpoints.down("xs")]: {
        fontSize: 30,
      },
    },
    h3: {
      fontWeight: 700,
      fontSize: 48,
      lineHeight: 1.15,
      [defaultTheme.breakpoints.down("xs")]: {
        fontSize: 24,
      },
    },
    h4: {
      fontWeight: 700,
      fontSize: 34,
      lineHeight: 1.15,
    },
    h5: {
      fontWeight: 700,
      fontSize: 24,
      lineHeight: 1.15,
    },
    h6: {
      fontWeight: 400,
      fontSize: 20,
      lineHeight: 1.15,
    },
    subtitle1: {
      fontWeight: 400,
      fontSize: 20,
    },
    subtitle2: {
      fontWeight: 400,
      fontSize: 20,
    },
    body1: {
      fontWeight: 400,
      fontSize: 18,
      lineHeight: 1.6,
      letterSpacing: 0.25,
      color: "rgb(102, 100, 125)",
    },
    body2: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: 1.6,
      letterSpacing: 0.25,
      color: "rgb(102, 100, 125)",
    },
    button: {
      fontWeight: 900,
      fontSize: 16,
      letterSpacing: 1.5,
    },
    caption: {
      fontWeight: 400,
      fontStyle: "italic",
      fontSize: 14,
      lineHeight: 2.4,
      display: "block",
      textAlign: "center",
    },
    overline: {
      fontWeight: 700,
      fontSize: 16,
      lineHeight: 1.6,
      textTransform: "none",
      letterSpacing: 0.5,
    },
  },
};
